import { api, API } from "./api";

export const loadRazorpay = () =>
  new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });

export const getPaymentConfig = () => api.get("/payment/config").then((r) => r.data);

export const startRazorpayCheckout = async ({ amount, customer, notes, orderId, onSuccess, onFailure }) => {
  const cfg = await getPaymentConfig();
  if (!cfg.enabled) {
    onFailure?.("Payment gateway is not configured yet. Please use WhatsApp checkout for now.");
    return;
  }
  const ok = await loadRazorpay();
  if (!ok) return onFailure?.("Could not load payment gateway. Please try again.");
  const orderRes = await api.post("/payment/create-order", { amount, notes });
  const rzpOrder = orderRes.data;

  const options = {
    key: cfg.key_id,
    amount: rzpOrder.amount,
    currency: "INR",
    order_id: rzpOrder.id,
    name: "Sugandhi Flowers",
    description: "Handcrafted crochet bouquets",
    theme: { color: "#D81B60" },
    prefill: {
      name: customer?.name || "",
      contact: customer?.phone || "",
      email: customer?.email || "",
    },
    handler: async (response) => {
      try {
        await api.post("/payment/verify", { ...response, order_id: orderId });
        onSuccess?.(response);
      } catch (e) {
        onFailure?.("Payment verification failed");
      }
    },
    modal: {
      ondismiss: () => onFailure?.("Payment cancelled — your bucket is safe"),
      handleback: false,  // BUG FIX: prevent browser back from navigating away
      escape: true,
      backdropclose: false,
      animation: true,
    },
    retry: { enabled: false },
  };
  const rzp = new window.Razorpay(options);
  rzp.on("payment.failed", (resp) => {
    onFailure?.(resp?.error?.description || "Payment failed");
  });
  rzp.open();
};
